import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppBar, Box, Toolbar } from "@mui/material";

import Home from "./home";
import HomeContent from "./homeContent";
import WebAppDevelopment from "./WebDevelopment";
import ECommerceDev from "./ECommerceDev";
import ApplicationPortal from "./EPortalDev";
import AndroidDevelopment from "./AndroidDevelopment";
import IOSDevelopment from "./iOSDevelopment";
import CrossPlatForm from "./crossPlatForm";
import SoftWareSolution from "./softwareSolutions";
import UIUX from "./uiux";
import DevopsDevelopment from "./devops_development";
import POSDevelopment from "./pos_develpment";
import AndroidTraining from "./AndroidTraining";
import IOSTraining from "./iOSTraining";
import DevopsServerTraining from "./devops_server_training";
import AboutUsLinus100 from "./aboutLinus100";
import Contact from "./contact";

function App() {
  const theme = createTheme({
    components: {
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: "black",
            "&:hover": {
              backgroundColor: "#f0f0f0",
              color: "#764ba2",
            },
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: "#fff",
          },
        },
      },
    },
  });

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
          }}
        >
          {/* Header */}
          <AppBar position="static">
            <Toolbar>
              <Home />
            </Toolbar>
          </AppBar>

          <Routes>
            <Route path="/" element={<HomeContent />} />
            <Route path="/home" element={<HomeContent />} />
            <Route
              path="/web-application-development"
              element={<WebAppDevelopment />}
            />
            <Route path="/e-commerce-development" element={<ECommerceDev />} />
            <Route path="/application_portal" element={<ApplicationPortal />} />
            <Route
              path="/android_development"
              element={<AndroidDevelopment />}
            />
            <Route path="/ios_development" element={<IOSDevelopment />} />
            <Route
              path="/cross_platform_technology"
              element={<CrossPlatForm />}
            />
            <Route path="/software_solutions" element={<SoftWareSolution />} />
            <Route path="/ui_ux_solutions" element={<UIUX />} />
            <Route path="/dev_ops_solution" element={<DevopsDevelopment />} />
            <Route
              path="/pos_development_solution"
              element={<POSDevelopment />}
            />
            <Route path="/android_training" element={<AndroidTraining />} />
            <Route path="/ios_training" element={<IOSTraining />} />
            <Route
              path="/server_devops_training"
              element={<DevopsServerTraining />}
            />
            <Route path="/about_us_linus100" element={<AboutUsLinus100 />} />
            <Route path="/contact_us" element={<Contact />} />
          </Routes>
        </Box>
      </ThemeProvider>
    </Router>
  );
}

export default App;
